module.exports = __webpack_public_path__ + "static/media/quom.404e00ee.png";